(()=>{
  if(window.bbcProductSticky)return;window.bbcProductSticky=true;
  const instances=new Map();
  const visible=e=>{if(!e)return false;const r=e.getBoundingClientRect(),s=getComputedStyle(e);return r.width>0&&r.height>0&&s.visibility!=='hidden'&&s.display!=='none';};
  function mount(section){
    if(instances.has(section)||section.closest('.Modal,.Drawer'))return;
    const form=section.querySelector('form.ProductForm'),button=form?.querySelector('.ProductForm__AddToCart');
    if(!button)return;
    const gift=form.querySelector('[data-gift-data]');
    if(gift&&JSON.parse(gift.textContent).mobileSticky!==false)return;
    const abort=new AbortController(),signal=abort.signal;
    const bar=document.createElement('div');bar.className='ProductSticky';bar.hidden=true;
    const proxy=document.createElement('button');proxy.type='button';proxy.className='Button Button--primary Button--full';bar.append(proxy);document.body.append(bar);
    let frame;
    const sync=()=>{
      frame=null;
      const label=button.textContent.trim().replace(/\s+/g,' ');
      const price=[...section.querySelectorAll('.ProductMeta__Price:not(.Price--compareAt)')].find(visible)?.textContent.trim()||'';
      const text=label+(price&&!label.replace(/\s/g,'').includes(price.replace(/\s/g,''))?' · '+price:'');
      if(proxy.textContent!==text)proxy.textContent=text;
      proxy.disabled=button.disabled;
      const overlay=[...document.querySelectorAll('.Drawer[aria-hidden="false"],.Modal[aria-hidden="false"],[role="dialog"][aria-modal="true"],#shopify-pc__banner')].some(visible);
      const preview=document.querySelector('#PBarNextFrameWrapper,#preview-bar-iframe');
      const offset=visible(preview)?Math.max(0,innerHeight-preview.getBoundingClientRect().top):0;
      bar.style.bottom=offset+'px';document.body.style.setProperty('--product-sticky-offset',offset+'px');
      const rect=button.getBoundingClientRect();
      const normalVisible=rect.top>=90&&rect.bottom<=innerHeight-offset;
      bar.hidden=!matchMedia('(max-width:640px)').matches||overlay||normalVisible||!visible(button);
      document.body.classList.toggle('product-sticky-active',!bar.hidden);
    };
    const refresh=()=>{if(!frame)frame=requestAnimationFrame(sync);};
    proxy.addEventListener('click',()=>{
      if(button.disabled)return;
      if(!form.checkValidity()){form.reportValidity();form.querySelector(':invalid')?.scrollIntoView({block:'center'});return;}
      button.click();refresh();
    },{signal});
    const formObserver=new MutationObserver(refresh);formObserver.observe(form,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','class','aria-busy']});
    const overlayObserver=new MutationObserver(refresh);overlayObserver.observe(document.body,{subtree:true,attributes:true,attributeFilter:['aria-hidden','class']});
    const intersection=new IntersectionObserver(refresh);intersection.observe(button);
    window.addEventListener('scroll',refresh,{passive:true,signal});window.addEventListener('resize',refresh,{passive:true,signal});window.visualViewport?.addEventListener('resize',refresh,{passive:true,signal});
    form.addEventListener('change',refresh,{signal});section.addEventListener('variant:changed',refresh,{signal});
    instances.set(section,()=>{abort.abort();formObserver.disconnect();overlayObserver.disconnect();intersection.disconnect();cancelAnimationFrame(frame);bar.remove();document.body.classList.remove('product-sticky-active');instances.delete(section);});
    sync();
  }
  const init=()=>document.querySelectorAll('[data-section-type="product"]').forEach(mount);
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:unload',e=>{for(const [section,cleanup] of instances)if(e.target===section||e.target.contains(section))cleanup();});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
